import type { Modify } from '@udecode/utils';

import { Editor, type EditorLevelsOptions } from 'slate';

import type { ENode, TNode, TNodeMatch } from '../node/TNode';
import type { TNodeEntry } from '../node/TNodeEntry';
import type { TEditor, Value } from './TEditor';

export type GetLevelsOptions<V extends Value = Value> = Modify<
  NonNullable<EditorLevelsOptions<TNode>>,
  {
    match?: TNodeMatch<ENode<V>>;
  }
>;

/** Iterate through all of the levels at a location. */
export const getLevels = <N extends ENode<V>, V extends Value = Value>(
  editor: TEditor<V>,
  options?: GetLevelsOptions<V>
): Generator<TNodeEntry<N>, void, undefined> =>
  Editor.levels(editor as any, options as any) as any;
